var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"method":"POST","action":_vm.serverUrl + '/download',"target":"_blank"}},[_c('input',{attrs:{"type":"hidden","name":"queryParams"},domProps:{"value":_vm.queryParams}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }